import { gql } from 'apollo-angular';

// #735: schmaler Lesepfad nur fuer den einmaligen Sprach-Abgleich pro Session.
// Bewusst NICHT die dicke USERS_QUERY des Profils — der Abgleich laeuft fuer jeden
// eingeloggten Nutzer, auch fuer die, die ihr Profil nie oeffnen.
export const GET_CURRENT_USER_LANGUAGE_QUERY = gql`
  query getCurrentUserLanguage {
    getCurrentUser {
      id
      preferredLanguage
    }
  }
`;

export interface CurrentUserLanguageResponse {
  getCurrentUser: {
    id: string;
    preferredLanguage: string;
  };
}
